/**
 * @generated SignedSource<<8f7858c133867cb3eb934be2a3a73b78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileQueryRendererQuery$variables = {
  patronLoyalty: boolean;
};
export type ProfileQueryRendererQuery$data = {
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly club: {
          readonly name: string;
          readonly " $fragmentSpreads": FragmentRefs<"AccountSettings_Club" | "ClubSettings_Club" | "FacilityLogoFragment_club">;
        };
        readonly " $fragmentSpreads": FragmentRefs<"ClubSettings_customer">;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ProfileInfo_ClientProfile">;
    } | null | undefined;
    readonly user: {
      readonly email: string | null | undefined;
      readonly firstName?: string | null | undefined;
      readonly id: string;
      readonly lastName?: string | null | undefined;
      readonly phoneNumber?: {
        readonly nationalNumber: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ProfileQueryRendererQuery = {
  response: ProfileQueryRendererQuery$data;
  variables: ProfileQueryRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patronLoyalty"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationalNumber",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "patronLoyalty",
    "variableName": "patronLoyalty"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumber",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countryCode",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "package",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingType",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "packageDueDate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "SquareCardOnFile",
  "kind": "LinkedField",
  "name": "squareCard",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expYear",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v21 = {
  "kind": "Literal",
  "name": "saleAvailability",
  "value": "PUBLIC"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileQueryRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhoneNumber",
                    "kind": "LinkedField",
                    "name": "phoneNumber",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "MemberUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProfileInfo_ClientProfile"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "args": (v6/*: any*/),
                    "kind": "FragmentSpread",
                    "name": "ClubSettings_customer"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "FacilityLogoFragment_club"
                      },
                      {
                        "args": (v6/*: any*/),
                        "kind": "FragmentSpread",
                        "name": "ClubSettings_Club"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AccountSettings_Club"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProfileQueryRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhoneNumber",
                    "kind": "LinkedField",
                    "name": "phoneNumber",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "MemberUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isClientProfile"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientClass",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v11/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v12/*: any*/),
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v2/*: any*/),
                          (v12/*: any*/),
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "activePackages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "status",
                            "value": "ACTIVE"
                          }
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberPackageEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberPackage",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderConnection",
                                    "kind": "LinkedField",
                                    "name": "orders",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrderEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Order",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v14/*: any*/),
                                              (v15/*: any*/),
                                              (v1/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "memberPackages(status:\"ACTIVE\")"
                      },
                      {
                        "alias": "upcomingPackages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "status",
                            "value": "UPCOMING"
                          }
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberPackageEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberPackage",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v1/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderConnection",
                                    "kind": "LinkedField",
                                    "name": "orders",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrderEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Order",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              (v1/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "memberPackages(status:\"UPCOMING\")"
                      },
                      (v1/*: any*/),
                      {
                        "alias": "allGiftCards",
                        "args": null,
                        "concreteType": "SquareGiftCardConnection",
                        "kind": "LinkedField",
                        "name": "squareGiftCards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SquareGiftCardEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SquareGiftCard",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v1/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ganLastFour",
                                    "storageKey": null
                                  },
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "squareId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "createdAt",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "patronLoyalty",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SquareLoyaltyAccount",
                            "kind": "LinkedField",
                            "name": "squareLoyaltyAccount",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SquareLoyaltyAccountExpiringPointDeadline",
                                "kind": "LinkedField",
                                "name": "expiringPointDeadlines",
                                "plural": true,
                                "selections": [
                                  (v1/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "expiresAt",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "alias": "memberships",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "MEMBERSHIP"
                          }
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": "memberPackages(type:\"MEMBERSHIP\")"
                      },
                      {
                        "alias": "packages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "STANDARD"
                          }
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": "memberPackages(type:\"STANDARD\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RaincheckConnection",
                        "kind": "LinkedField",
                        "name": "rainchecks",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "logoImage",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clubPolicyLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "supportsPublic",
                        "storageKey": null
                      },
                      {
                        "condition": "patronLoyalty",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timeZone",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SquareLoyaltyProgram",
                            "kind": "LinkedField",
                            "name": "squareLoyaltyProgram",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "terminologyOne",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "terminologyOther",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SquareLoyaltyRewardTier",
                                "kind": "LinkedField",
                                "name": "rewardTiers",
                                "plural": true,
                                "selections": [
                                  (v1/*: any*/),
                                  (v7/*: any*/),
                                  (v18/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "alias": "memberships",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "packageType",
                            "value": "MEMBERSHIP"
                          },
                          (v21/*: any*/)
                        ],
                        "concreteType": "PackageConnection",
                        "kind": "LinkedField",
                        "name": "packages",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": "packages(packageType:\"MEMBERSHIP\",saleAvailability:\"PUBLIC\")"
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "packageType",
                            "value": "STANDARD"
                          },
                          (v21/*: any*/)
                        ],
                        "concreteType": "PackageConnection",
                        "kind": "LinkedField",
                        "name": "packages",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": "packages(packageType:\"STANDARD\",saleAvailability:\"PUBLIC\")"
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v20/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "49615b205f66a25b40f45d6bb3e806fb",
    "id": null,
    "metadata": {},
    "name": "ProfileQueryRendererQuery",
    "operationKind": "query",
    "text": "query ProfileQueryRendererQuery(\n  $patronLoyalty: Boolean!\n) {\n  session {\n    user {\n      __typename\n      id\n      email\n      ... on MemberUser {\n        id\n        firstName\n        lastName\n        email\n        phoneNumber {\n          nationalNumber\n          id\n        }\n      }\n    }\n    currentClientProfile {\n      __typename\n      ...ProfileInfo_ClientProfile\n      member {\n        __typename\n        ...ClubSettings_customer_3CuyyL\n        club {\n          name\n          ...FacilityLogoFragment_club\n          ...ClubSettings_Club_3CuyyL\n          ...AccountSettings_Club\n          id\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment AccountSettings_Club on Club {\n  supportsPublic\n}\n\nfragment ClubSettings_Club_3CuyyL on Club {\n  name\n  clubPolicyLink\n  supportsPublic\n  timeZone @include(if: $patronLoyalty)\n  squareLoyaltyProgram @include(if: $patronLoyalty) {\n    status\n    terminologyOne\n    terminologyOther\n    rewardTiers {\n      id\n      name\n      points\n    }\n    id\n  }\n  ...CurrentPackagesModal_club\n  ...useClubHasMemberships_club\n  ...useClubHasPackages_club\n}\n\nfragment ClubSettings_customer_3CuyyL on Customer {\n  ...useGetPackageNeedingAttention_customer\n  ...GiftCardsModal_customer\n  squareLoyaltyAccount @include(if: $patronLoyalty) {\n    balance\n    expiringPointDeadlines {\n      id\n      points\n      expiresAt\n    }\n    id\n  }\n  memberships: memberPackages(type: MEMBERSHIP) {\n    count\n  }\n  packages: memberPackages(type: STANDARD) {\n    count\n  }\n  rainchecks {\n    count\n  }\n}\n\nfragment CurrentPackagesModal_club on Club {\n  name\n}\n\nfragment FacilityLogoFragment_club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment GiftCard_squareGiftCard on SquareGiftCard {\n  __typename\n  id\n  balance\n  ganLastFour\n  status\n  squareId\n  createdAt\n}\n\nfragment GiftCardsList_customer on Customer {\n  allGiftCards: squareGiftCards {\n    edges {\n      node {\n        ...GiftCard_squareGiftCard\n        id\n        balance\n        status\n      }\n    }\n  }\n}\n\nfragment GiftCardsModal_customer on Customer {\n  id\n  ...GiftCardsList_customer\n}\n\nfragment ProfileInfo_ClientProfile on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    clientClass\n    ... on Member {\n      profileImage {\n        publicId: renderingKey\n      }\n      user {\n        email\n        fullName\n        firstName\n        lastName\n        phoneNumber {\n          nationalNumber\n          countryCode\n          id\n        }\n        id\n      }\n    }\n    ... on Customer {\n      profileImage {\n        publicId: renderingKey\n      }\n      user {\n        fullName\n        firstName\n        lastName\n        email\n        phoneNumber {\n          nationalNumber\n          countryCode\n          id\n        }\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment packageMissingPaymentMethod_memberPackage on MemberPackage {\n  squareCard {\n    id\n  }\n  package {\n    __typename\n    billingType\n    id\n  }\n}\n\nfragment packageOrderNeedsPayment_order on Order {\n  status\n  packageDueDate\n}\n\nfragment packagePaymentMethodExpired_memberPackage on MemberPackage {\n  package {\n    __typename\n    billingType\n    id\n  }\n  orders {\n    edges {\n      node {\n        packageDueDate\n        id\n      }\n    }\n  }\n  squareCard {\n    id\n    expMonth\n    expYear\n  }\n}\n\nfragment useClubHasMemberships_club on Club {\n  supportsPublic\n  memberships: packages(packageType: MEMBERSHIP, saleAvailability: PUBLIC) {\n    count\n  }\n}\n\nfragment useClubHasPackages_club on Club {\n  supportsPublic\n  packages(packageType: STANDARD, saleAvailability: PUBLIC) {\n    count\n  }\n}\n\nfragment useGetPackageNeedingAttention_customer on Customer {\n  activePackages: memberPackages(status: ACTIVE) {\n    edges {\n      node {\n        id\n        package {\n          __typename\n          id\n        }\n        orders {\n          edges {\n            node {\n              ...packageOrderNeedsPayment_order\n              id\n            }\n          }\n        }\n        ...packageMissingPaymentMethod_memberPackage\n        ...packagePaymentMethodExpired_memberPackage\n      }\n    }\n  }\n  upcomingPackages: memberPackages(status: UPCOMING) {\n    edges {\n      node {\n        package {\n          __typename\n          id\n        }\n        id\n        ...packageMissingPaymentMethod_memberPackage\n        ...packagePaymentMethodExpired_memberPackage\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fd44753bb2df020e65dbd2d72b6e9490";

export default node;
